import { TransactionDirection, TransactionItem } from '@/types/transactions';
import { formatCurrency } from '@/utils/currency';
import { Typography } from '@mui/material';

type TransactionAmountProps = {
  transaction: TransactionItem;
  isSmall?: boolean;
};

export default function TransactionAmount({
  transaction,
  isSmall = false,
}: TransactionAmountProps) {
  const { direction, amount } = transaction;

  const isOutgoing = direction === TransactionDirection.Outgoing;
  const isIncoming = direction === TransactionDirection.Incoming;

  let formattedAmount = formatCurrency({ amount: amount.value });
  formattedAmount = isOutgoing
    ? `-${formattedAmount}`
    : isIncoming
      ? `+${formattedAmount}`
      : formattedAmount;

  return (
    <Typography
      sx={{
        mt: 0,
        color: isOutgoing
          ? 'error.main'
          : isIncoming
            ? 'success.main'
            : 'black',
      }}
      variant={isSmall ? 'caption' : 'body1'}>
      {formattedAmount}
    </Typography>
  );
}
